module.exports = __webpack_public_path__ + "img/call.62f15386.svg";